import { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { FaqModal } from '../FaqModal/FaqModal';

export const FaqIconModal: React.FC = () => {
    const [showFaqModal, setShowFaqModal] = useState(false);

    return (
        <>
            <FaInfoCircle className="cursor-pointer mr-2 mb-1" onClick={() => setShowFaqModal(true)} />

            <FaqModal isOpen={showFaqModal} onRequestClose={() => setShowFaqModal(false)} />
        </>
    );
};
